<blaze-dialog (closeDialog)="closeDialog()" [showFooter]="true" class="prompt-dialog">
  <div icon class="flex">
    <mat-icon svgIcon="save" />
  </div>

  <div title>
    Save New Theme
    @if (willApplyNewTheme()) {
      &nbsp;& Apply
    }
  </div>

  <form content class="modal-content" [formGroup]="form" (ngSubmit)="confirm()">
    <input
      #nameInput
      placeholder="Theme name"
      type="text"
      formControlName="name"
      class="w-full bd-text-input tall"
      required
      aria-label="Theme name"
      [attr.aria-invalid]="form.controls.name.invalid ? 'true' : null"
      [attr.aria-describedby]="isNameInUse ? 'theme-name-error' : null"
    />

    @if (isNameInUse) {
      <div
        id="theme-name-error"
        role="alert"
        class="mt-8 text-warn"
        data-cy="ThemeEditorSaveDialog:duplicateName"
      >
        This theme name is already in use. Please choose a different one.
      </div>
    }

    @if (canSaveAsBlazeTheme()) {
      <div class="mt-16">
        <blaze-checkbox formControlName="saveAsBlazeTheme">
          Save as a new default theme version
        </blaze-checkbox>
      </div>
    }
  </form>

  <div footer class="modal-footer !justify-center">
    <button
      (click)="confirm()"
      [disabled]="!form.valid"
      class="bd-btn bd-btn-primary uppercase relative px-16 py-8"
    >
      <span [class.invisible]="loading()">Save as</span>
      <blaze-element-loading-indicator [isVisible]="loading()" mode="white" />
    </button>
  </div>
</blaze-dialog>
